<template>
  <div>
    <div class="row">
      <div class="col-md-2">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-primary`" size="35">
              <feather-icon size="21" :icon="'FileIcon'" />
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ visibleTotal }}
              </h2>
              <span>Total de Atividades</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-2">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-primary`" size="35">
              <feather-icon size="21" :icon="'FileIcon'" />
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.visibleActive }}
              </h2>
              <span>Atividades Ativas</span>
            </div>
          </b-card-body>
        </b-card>
      </div>

      <div class="col-md-2">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-warning`" size="35">
              <feather-icon size="21" :icon="'FileIcon'" />
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ visibleStatus0 }}
              </h2>
              <span> Não Iniciadas </span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-2">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="35">
              <i class="fas fa-ambulance" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ visibleRemovalsCount }}
              </h2>
              <span>Veículos em Remoção</span>
            </div>
          </b-card-body>
        </b-card>
      </div>

      <div class="col-md-2">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-success`" size="35">
              <i class="fas fa-mobile-alt" style="font-size: 20px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ visibleLastPositionRecent }}
              </h2>
              <span> Sincronizando </span>
            </div>
          </b-card-body>
        </b-card>
      </div>

      <div class="col-md-2">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="35">
              <i class="fas fa-mobile-alt" style="font-size: 20px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ visibleLastPositionOld }}
              </h2>
              <span> Não Sincronizando </span>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="title bold">Programação do Dia</div>
      </div>
      <div class="card-body">
        <div class="row mb-1">
          <div
            class="form-group col-md-3"
            v-if="$store.state.user.access_level != 4"
          >
            <label for="centrals"> {{ $t("Central") }}: </label>
            <v-select
              :options="centers"
              :reduce="(centers) => (centers ? centers.id : null)"
              :label="'name'"
              v-model="center_id"
              class="vselect"
              @input="changetUnitsCenter"
            />
          </div>
          <div
            class="form-group col-md-3"
            v-if="$store.state.user.access_level != 4"
          >
            <label for="unit"> {{ $t("Unit") }}: </label>

            <v-select
              :options="units"
              :reduce="(units) => (units ? units.id : null)"
              :label="'name'"
              v-model="unit_id"
              class="vselect"
              @input="getEntity"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="filter"> Filtrar por Status</label>

            <v-select
              :options="[
                { label: 'Em posição', id: 1 },
                { label: 'Em remoção', id: 3 },
                { label: 'Finalizado', id: 2 },
                { label: 'Ativas', id: 4 },
                { label: 'Não iniciado', id: 0 },
              ]"
              :reduce="(options) => (options ? options.id : null)"
              v-model="filterStatus_"
              class="vselect"
              @input="getEntity"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="filter"> Filtrar por Status do Dispositivo </label>

            <v-select
              :options="['Sincronizando', 'Não Sincronizando']"
              v-model="filterStatus"
              class="vselect"
              @input="getEntity"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="filter"> Filtrar por data </label>
            <input
              type="date"
              v-model="filterDate"
              @change="handleDateInput"
              class="form-control"
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-1">
            <router-link
              to="/mobile_position/videowall"
              class="btn btn-primary"
              @click="autoRefreshing"
            >
              Mapa
            </router-link>
          </div>
          <div class="col-md-2" v-if="!auto_refresh">
            <button class="btn btn-info" @click="getEntity">
              Atualizar <i class="fas fa-sync"></i>
            </button>
          </div>
          <div class="col-md-3" v-if="!auto_refresh">
            <button class="btn btn-success" @click="autoRefreshing">
              Atualizar Automaticamente <i class="fas fa-sync"></i>
            </button>
          </div>
          <div class="col-md-1" v-else>
            <button class="btn btn-danger" @click="autoRefreshing">
              Parar <i class="fas fa-sync"></i>
            </button>
          </div>
          <div class="col-md-3" v-if="auto_refresh">
            Proxima atualização em {{ timeLeft }} segundos
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Usuário</th>
                  <th scope="col">Unidade/Área</th>
                  <th scope="col">Status</th>
                  <th scope="col">Data Início Agenda</th>
                  <th scope="col">Data Início Real</th>
                  <th scope="col">Data Fim Agenda</th>
                  <th scope="col">Data Fim Real</th>
                  <th scope="col">Última Posição</th>
                  <th scope="col">Status Dispositivo</th>
                  <th scope="col">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="activity in visibleActivities" :key="activity.id">
                  <th scope="row">{{ activity.id }}</th>
                  <td>
                    {{ activity.name }}<br />
                    {{ activity.user ? activity.user.name : "-" }}<br />
                    ({{ activity.user ? activity.user.email : "-" }})
                  </td>

                  <td>
                    {{
                      activity.vehicle && activity.vehicle.unit
                        ? activity.vehicle.unit.name
                        : "-"
                    }}
                    <br />
                    <br />
                    ({{ activity.area ? activity.area.name : "-" }})
                  </td>
                  <td>
                    <span :class="badge(activity.status).class">{{
                      badge(activity.status).text
                    }}</span>
                  </td>
                  <td>{{ activity.start_date_f }}</td>
                  <td>{{ activity.actual_start_date_f }}</td>
                  <td>{{ activity.end_date_f }}</td>
                  <td>{{ activity.actual_end_date_f }}</td>
                  <td>{{ activity.last_position_f }}</td>
                  <td>
                    <span
                      :class="badgePosition(activity.status_position).class"
                      >{{ badgePosition(activity.status_position).text }}</span
                    >
                  </td>
                  <td>
                    <button
                      v-if="$store.state.user.access_level != 4"
                      class="btn btn-crud edit"
                      @click="restart(activity)"
                    >
                      <i class="fas fa-retweet"></i>
                    </button>
                    <br />
                    <button class="btn btn-crud info" @click="map(activity)">
                      <i class="fas fa-map-marker-alt"></i>
                    </button>
                    <br />
                    <button
                      class="btn btn-crud view"
                      @click="removals(activity)"
                    >
                      <i class="fas fa-ambulance"></i>
                    </button>
                    <br />
                    <button
                      v-if="$store.state.user.access_level != 4"
                      class="btn btn-crud delete"
                      @click="finish(activity)"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Mapa -->
    <div
      class="modal fade"
      id="modalMap"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalMapTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Informações do dispositivo
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="data_modal.position">
            <div class="row centered">
              <div class="col-md-2">
                <div class="bold">Bateria do Dispositivo</div>
                <div>
                  <i
                    :class="batteryIcon(data_modal.data.battery_info)"
                    class="fa fa-3x"
                  ></i>
                  <span>
                    <p>{{ data_modal.data.battery_info }}</p>
                  </span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="bold">Versão do Android</div>
                <div>
                  <i class="fab fa-android fa-3x"></i>
                  <span>
                    <p>{{ data_modal.data.device_version }}</p>
                  </span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="bold">Modelo do Dispositivo</div>
                <div>
                  <i class="fas fa-mobile-alt fa-2x mb-1"></i>
                  <span>
                    <p>{{ data_modal.data.device_name }}</p>
                  </span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="bold">IP do Dispositivo</div>
                <div>
                  <i class="fas fa-network-wired fa-2x mb-1"></i>
                  <span>
                    <p>{{ data_modal.data.device_ip }}</p>
                  </span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="bold">Última Posição</div>
                <div>
                  <i class="fas fa-clock fa-2x mb-1"></i>
                  <span>
                    <p>{{ data_modal.data.position_date }}</p>
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <GmapMap
                  :zoom="19"
                  :center="data_modal.position.coord"
                  style="width: 100%; height: 650px"
                >
                  <GmapMarker
                    :position="data_modal.position.coord"
                    style="width: 100px"
                  />
                </GmapMap>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Mapa -->
    <div
      class="modal fade"
      id="modalRemovals"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalRemovalsTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Remoções</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Número Ficha</th>
                  <th scope="col">Destino</th>
                  <th scope="col">Usuário</th>
                  <th scope="col">Veículo</th>
                  <th scope="col">Início da Remoção</th>
                  <th scope="col">Fim da Remoção</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="removal in data_modal_removal" :key="removal.id">
                  <th scope="row">{{ removal.id }}</th>
                  <td>{{ removal.card_number }}</td>
                  <td>{{ removal.destination_hospital }}</td>
                  <td>{{ removal.user ? removal.user.name : "-" }}</td>
                  <td>{{ removal.vehicle ? removal.vehicle.name : "-" }}</td>
                  <td>{{ removal.start_date }}</td>
                  <td>{{ removal.end_date }}</td>
                  <td>
                    <span
                      :class="
                        removal.status == 1
                          ? 'badge badge-success'
                          : 'badge badge-warning'
                      "
                      >{{
                        removal.status == 1 ? "Finalizado" : "Iniciado"
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visibleActive: 0,
      timeLeft: 20,
      intervalId: null,
      center_id: null,
      unit_id: null,
      filterStatus: null,
      filterStatus_: null,
      intervalIdChronometer: null,
      filterDate: null,
      auto_refresh: false,
      activities: [],
      centers: [{ id: null, name: "Todos" }],
      units: [{ id: null, name: "Todos" }],
      data_modal_removal: [],
      vehicleslist: [],
      data_modal: {},
      dashboard: {},
      selectedVehicle: null,
      filters: {},
      result: [],
      dateDebounceTimer: null,
    };
  },
  components: {},
  computed: {
    optionsWithAll() {
      return [{ id: null, name: "Todos" }, ...this.vehicleslist];
    },
    removalsCount() {
      if (!Array.isArray(this.activities)) return 0;
      return this.activities.filter((activity) => Number(activity.status) === 3)
        .length;
    },

    visibleActivities() {
      if (!Array.isArray(this.activities)) return [];
      return this.activities.filter((activity) => {
        const vehicle = activity.vehicle || {};
        if (this.center_id && vehicle.center_id != null) {
          if (Number(vehicle.center_id) !== Number(this.center_id))
            return false;
        }
        if (this.unit_id) {
          const unitId =
            vehicle.unit && (vehicle.unit.id || vehicle.unit_id)
              ? vehicle.unit.id || vehicle.unit_id
              : null;
          if (unitId == null) return false;
          if (Number(unitId) !== Number(this.unit_id)) return false;
        }
        return true;
      });
    },

    visibleTotal() {
      return this.visibleActivities.length;
    },

    visibleStatus0() {
      return this.visibleActivities.filter((a) => Number(a.status) === 0)
        .length;
    },

    visibleLastPositionRecent() {
      return this.visibleActivities.filter(
        (a) => Number(a.status_position) === 1 || a.status_position === true,
      ).length;
    },

    visibleLastPositionOld() {
      return this.visibleActivities.filter(
        (a) => !(Number(a.status_position) === 1 || a.status_position === true),
      ).length;
    },

    visibleRemovalsCount() {
      return this.visibleActivities.filter(
        (activity) => Number(activity.status) === 3,
      ).length;
    },
  },
  methods: {
    formatApiError(error) {
      try {
        if (error && error.response && error.response.data) {
          const data = error.response.data;
          if (typeof data === "string") return data;
          if (data.message) return data.message;
          return JSON.stringify(data);
        }
      } catch (e) {}
      return (error && error.message) || "Erro desconhecido";
    },

    batteryIcon(batteryLevel) {
      if (!batteryLevel) return "fa-battery-empty";
      batteryLevel = String(batteryLevel).replace("%", "");
      const value = Number(batteryLevel);
      if (isNaN(value)) return "fa-battery-empty";
      if (value > 80) return "fa-battery-full color-success";
      if (value > 60) return "fa-battery-three-quarters color-success";
      if (value > 40) return "fa-battery-half color-warning";
      if (value > 20) return "fa-battery-quarter color-warning";
      if (value <= 20) return "fa-battery-quarter color-danger";
      return "fa-battery-empty";
    },

    badge(id) {
      switch (id) {
        case 0:
          return { text: "Não iniciado", class: "badge badge-warning" };
        case 1:
          return { text: "Em posição", class: "badge badge-info" };
        case 2:
          return { text: "Finalizado", class: "badge badge-success" };
        case 3:
          return { text: "Em remoção", class: "badge badge-danger" };
        default:
          return { text: "N/A", class: "badge badge-secondary" };
      }
    },

    badgePosition(id) {
      if (id === true)
        return { text: "Sincronizando", class: "badge badge-success" };
      if (id === false) return { text: "Offline", class: "badge badge-danger" };
      return { text: "Offline", class: "badge badge-secondary" };
    },

    handleDateInput() {
      if (!this.filterDate || this.filterDate.length !== 10) {
        return;
      }
      if (this.dateDebounceTimer) {
        clearTimeout(this.dateDebounceTimer);
      }
      this.dateDebounceTimer = setTimeout(() => {
        this.getEntity();
      }, 1000);
    },

    getEntity() {
      const self = this;
      let api = self.$store.state.api + "get-activities";
      self.$loading(true);

      self.activities = [];

      let formattedDate = null;
      try {
        if (self.filterDate) {
          console.log("filterDate original:", self.filterDate);
          const parts = self.filterDate.split("-");
          if (parts.length === 3) {
            const [year, month, day] = parts;
            formattedDate = `${day}/${month}/${year}`;
          } else {
            formattedDate = self.filterDate;
          }
          console.log("formattedDate enviada:", formattedDate);
        }
      } catch (e) {
        console.error("Erro ao formatar data:", e);
        formattedDate = self.filterDate;
      }

      self.filters = {
        unit_id: self.unit_id,
        status: self.filterStatus,
        status_: self.filterStatus_,
        date: formattedDate,
      };

      axios
        .post(api, self.filters)
        .then((response) => {
          self.activities =
            response.data && response.data.data
              ? response.data.data
              : response.data;
          self.$loading(false);
          self.getDashboard();
        })
        .catch((error) => {
          const message = self.formatApiError(error);
          swal("Erro", message, "error");
          self.$loading(false);
        });
    },

    getDashboard() {
      const self = this;
      let api = self.$store.state.api + "get-activities/dashboard";

      self.filters = {
        unit_id: self.unit_id,
      };

      axios
        .post(api, self.filters)
        .then((response) => {
          self.dashboard = response.data;
        })
        .catch((error) => {
          self.$error(error);
          self.$loading(false);
        });
    },

    restart(props) {
      const self = this;
      let api = self.$store.state.api + "restart_activity/" + props.id;

      swal({
        title: "Deseja reiniciar a atividade?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "A atividade não foi reiniciada!", "info");
            break;
          case "confirm":
            axios
              .post(api, {})
              .then(() => {
                swal("Sucesso", "A atividade foi reiniciada!", "success");
                self.getEntity();
              })
              .catch((error) => {
                const message = self.formatApiError(error);

                swal("Erro", message, "error");
              });
            break;
        }
      });
    },

    map(props) {
      const self = this;
      let api = self.$store.state.api + "posicao-mobile/position";

      axios
        .post(api, props)
        .then((response) => {
          const data =
            response.data && response.data.length
              ? response.data[0]
              : response.data;
          if (!data || !data.position || !data.position.coord) {
            swal(
              "Aviso",
              "Posição não encontrada para este usuário",
              "warning",
            );
            return;
          }
          self.data_modal = data;

          const lat = Number(self.data_modal.position.coord.lat);
          const lng = Number(self.data_modal.position.coord.lng);
          self.data_modal.position.coord.lat = isNaN(lat) ? 0 : lat;
          self.data_modal.position.coord.lng = isNaN(lng) ? 0 : lng;

          $("#modalMap").modal("show");
        })
        .catch((error) => {
          const message = self.formatApiError(error);

          swal("Erro", message, "error");
        });
    },

    removals(props) {
      const self = this;
      let api = self.$store.state.api + "get-activities/removals";

      axios
        .post(api, props)
        .then((response) => {
          self.data_modal_removal =
            response.data && response.data.data
              ? response.data.data
              : response.data;
          $("#modalRemovals").modal("show");
        })
        .catch((error) => {
          const message = self.formatApiError(error);

          swal("Erro", message, "error");
        });
    },

    finish(props) {
      const self = this;
      let api = self.$store.state.api + "end_activity";

      swal({
        title: "Deseja encerrar a atividade?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: { text: "Não", value: "cancel", className: "btn-danger" },
          confirm: { text: "Sim", value: "confirm" },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "A atividade não foi encerrada!", "info");
            break;
          case "confirm":
            axios
              .post(api, props)
              .then((response) => {
                const res = response.data;
                if (res && res.status === "false") {
                  // API retorna mensagem explícita quando há remoção ativa
                  swal(
                    "Erro",
                    res.message || "Não foi possível encerrar a atividade",
                    "error",
                  );
                } else {
                  swal("Sucesso", "Atividade encerrada com sucesso", "success");
                  self.getEntity();
                }
              })
              .catch((error) => {
                const message = self.formatApiError(error);

                swal("Erro", message, "error");
              });
            break;
        }
      });
    },

    autoRefreshing() {
      const self = this;
      self.startCountdown();

      if (!self.auto_refresh) {
        self.intervalId = setInterval(() => {
          self.getEntity();
          self.startCountdown();
        }, 20000);
      } else {
        if (self.intervalId) clearInterval(self.intervalId);
      }

      self.auto_refresh = !self.auto_refresh;
    },

    startCountdown() {
      if (this.intervalIdChronometer) clearInterval(this.intervalIdChronometer);
      this.timeLeft = 20;

      this.intervalIdChronometer = setInterval(() => {
        this.timeLeft--;
        if (this.timeLeft < 0) this.timeLeft = 20;
      }, 1000);
    },

    async changetUnitsCenter(center_id) {
      this.unit_id = null;

      if (center_id) {
        await this.getUnitsCenter(center_id);
        this.$nextTick(() => {
          this.unit_id = null;
        });
      } else {
        this.units = [{ id: null, name: "Todos" }];
        this.$nextTick(() => {
          this.unit_id = null;
        });
      }

      this.filterVehicles();

      this.getEntity();
    },

    async getUnitsCenter(center_id) {
      try {
        const api = `${this.$store.state.api}centers/unit/${center_id}`;
        const response = await axios.get(api);
        const data =
          response.data && response.data.data
            ? response.data.data
            : response.data;
        this.units = [
          { id: null, name: "Todos" },
          ...(Array.isArray(data) ? data : []),
        ];
      } catch (error) {
        const message = this.formatApiError(error);
        this.units = [{ id: null, name: "Todos" }];
        swal("Erro", message, "error");
      }
    },

    async getVehicles() {
      try {
        const api = this.$store.state.api + "vehicles";
        const response = await axios.get(api);
        const payload =
          response.data && response.data.data
            ? response.data.data
            : response.data;
        this.result = Array.isArray(payload) ? payload : [];
        this.vehicleslist = this.result;
      } catch (error) {
        const message = this.formatApiError(error);

        swal("Erro", message, "error");
      }
    },

    filterVehicles() {
      let filteredVehicles = Array.isArray(this.result) ? [...this.result] : [];

      if (this.center_id && this.unit_id) {
        filteredVehicles = filteredVehicles.filter(
          (vehicle) =>
            vehicle.center_id === this.center_id &&
            vehicle.unit_id === this.unit_id,
        );
      } else if (this.center_id) {
        filteredVehicles = filteredVehicles.filter(
          (vehicle) => vehicle.center_id === this.center_id,
        );
      } else if (this.selectedVehicle) {
        const svId =
          typeof this.selectedVehicle === "number"
            ? this.selectedVehicle
            : this.selectedVehicle.id || null;
        if (svId !== null) {
          filteredVehicles = filteredVehicles.filter(
            (vehicle) => vehicle.id === svId,
          );
        }
      }
      this.vehicleslist = filteredVehicles;
    },

    getCenters() {
      const self = this;
      let api = this.$store.state.api + "centers/";
      axios
        .get(api)
        .then((response) => {
          const data =
            response.data && response.data.data
              ? response.data.data
              : response.data;
          this.centers = [{ id: null, name: "Todos" }, ...data];
        })
        .catch((error) => {
          const message = self.formatApiError(error);

          swal("Erro", message, "error");
        });
    },
  },
  mounted() {
    const self = this;
    self.getCenters();
    self.getVehicles();
    self.getEntity();
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.intervalIdChronometer) clearInterval(this.intervalIdChronometer);
  },
};
</script>

<style scoped>
.color-success {
  color: green;
}

.color-warning {
  color: rgb(212, 185, 62);
}

.color-danger {
  color: red;
}
</style>
